import { SVGProps } from 'react';

export const Savings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="73"
    height="73"
    viewBox="0 0 73 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.4445 59.0735H53.7038V45.6477H59.0742V53.7032H64.4445V59.0735ZM56.3891 40.2775C47.5066 40.2775 40.2781 47.5087 40.2781 56.3885C40.2781 65.2738 47.5066 72.4996 56.3891 72.4996C65.2717 72.4996 72.5001 65.2738 72.5001 56.3885C72.5001 47.5087 65.2717 40.2775 56.3891 40.2775V40.2775Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.6669 22.5554H27.3892C26.4999 22.5554 25.7781 23.2772 25.7781 24.1665C25.7781 25.0558 26.4999 25.7776 27.3892 25.7776H30.6114C35.0516 25.7776 38.6669 29.3929 38.6669 33.8331C38.6669 37.7255 35.8958 40.9768 32.2225 41.7275V45.1108H25.7781V41.8886H19.3337V35.4442H30.6114C31.5008 35.4442 32.2225 34.7225 32.2225 33.8331C32.2225 32.9438 31.5008 32.222 30.6114 32.222H27.3892C22.949 32.222 19.3337 28.6067 19.3337 24.1665C19.3337 20.2741 22.1048 17.0229 25.7781 16.2721V12.8888H32.2225V16.111H38.6669V22.5554ZM54.7775 35.4443C55.6024 35.4443 56.4111 35.5119 57.2103 35.6118C57.7097 33.4852 57.9997 31.2812 57.9997 28.9998C57.9997 13.0113 44.9884 0 28.9998 0C13.0113 0 0 13.0113 0 28.9998C0 44.9884 13.0113 57.9997 28.9998 57.9997C31.2779 57.9997 33.4852 57.7097 35.615 57.207C35.5119 56.4111 35.4443 55.6024 35.4443 54.7775C35.4443 44.0991 44.1023 35.4443 54.7775 35.4443V35.4443Z"
      fill="currentColor"
    />
  </svg>
);
